import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { CONTACT_BOX_IN_CART_CONVERTER_TOKEN, ContactBoxInCartConverter } from './contact-box-in-cart.component.converter'
import { FsComponentConverter } from 'fs-spartacus-common'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        contactBoxTechnicalFeature: {
          module: () => import('./contact-box-in-cart.module').then((m) => m.ContactBoxInCartModule),
          cmsComponents: ['contactbox_in_cart', 'ContactBoxComponent']
        },
      }
    }),
    {
      provide: CONTACT_BOX_IN_CART_CONVERTER_TOKEN,
      useExisting: ContactBoxInCartConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        contactbox_in_cart: CONTACT_BOX_IN_CART_CONVERTER_TOKEN,
        ContactBoxComponent: CONTACT_BOX_IN_CART_CONVERTER_TOKEN
      },
      multi: true
    }
  ]
})
export class ContactBoxInCartFeatureModule {}
